var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { CurrentOrderService } from './../currentOrder.service';
import { Component } from '@angular/core';
import { OrderValidation } from '../orderValidation';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
var $ = require('jquery');
global.jQuery = $;
require('metismenu');
var OrderCompletedComponent = (function () {
    function OrderCompletedComponent(translate, currentOrderService, orderValidation) {
        this.translate = translate;
        this.currentOrderService = currentOrderService;
        this.orderValidation = orderValidation;
    }
    OrderCompletedComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.currentOrderService.setMenuVisibility({
            part: true,
            address: true,
            billing: true,
            shipping: true,
            summary: true,
            completed: true
        });
        this.isInviteValid = false;
        this.currentOrderService.resetOrder();
        this.currentOrderService.orderType.subscribe(function (orderType) { return _this.orderType = orderType; });
        this.setUrl();
    };
    OrderCompletedComponent.prototype.setUrl = function () {
        if (this.translate.currentLang == "fr") {
            $('#maintenance').attr("href", "http://www.ptchronos.com/fr-ca/pieces-et-service/entretien-preventif/");
            $('#feedback').attr("href", "http://www.cvent.com/d/95qkyv/3B?lang=fr-FR");
            $('#retrofits').attr("href", "http://www.ptchronos.com/fr-ca/pieces-et-service/retrofits-and-upgrades/");
            $('#spare-parts').attr("href", "http://www.cvent.com/d/05qnmv/3B?lang=fr-FR");
        }
    };
    OrderCompletedComponent.prototype.showInviteConfirmation = function () {
        var _this = this;
        var title = "";
        var message = "";
        this.translate.get('ORDER.FORM.COMPLETED.SWAL_SUCCESS').subscribe(function (value) {
            title = value;
        });
        this.translate.get('ORDER.FORM.COMPLETED.SWAL_SUCCESS_MESSAGE').subscribe(function (value) {
            message = value;
        });
        swal({
            title: title,
            text: this.email + ' ' + message,
            type: 'success',
            showCancelButton: false,
            confirmButtonText: 'Ok',
        }).then(function () {
            _this.email = "";
            _this.isInviteValid = false;
        });
    };
    OrderCompletedComponent.prototype.showInviteError = function () {
        var title = "";
        var message = "";
        this.translate.get('ORDER.FORM.COMPLETED.SWAL_ERROR').subscribe(function (value) {
            title = value;
        });
        this.translate.get('ORDER.FORM.COMPLETED.SWAL_ERROR_MESSAGE').subscribe(function (value) {
            message = value;
        });
        swal({
            title: title,
            text: message,
            type: 'error',
            showCancelButton: false,
            confirmButtonText: 'Ok',
        }).then(function () { });
    };
    OrderCompletedComponent.prototype.validateEmail = function () {
        this.isInviteValid = this.orderValidation.isEmailValid(this.email);
    };
    OrderCompletedComponent = __decorate([
        Component({
            selector: 'cx-ordercompleted',
            templateUrl: './ordercompleted.component.html',
        }),
        __metadata("design:paramtypes", [TranslateService,
            CurrentOrderService,
            OrderValidation])
    ], OrderCompletedComponent);
    return OrderCompletedComponent;
}());
export { OrderCompletedComponent };
var OrderCompletedGuard = (function () {
    function OrderCompletedGuard(orderValidation) {
        this.orderValidation = orderValidation;
    }
    OrderCompletedGuard.prototype.canActivate = function () {
        return this.orderValidation.isOrderValid();
    };
    OrderCompletedGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [OrderValidation])
    ], OrderCompletedGuard);
    return OrderCompletedGuard;
}());
export { OrderCompletedGuard };
var QuoteCompletedGuard = (function () {
    function QuoteCompletedGuard(orderValidation) {
        this.orderValidation = orderValidation;
    }
    QuoteCompletedGuard.prototype.canActivate = function () {
        return this.orderValidation.isQuoteValid();
    };
    QuoteCompletedGuard = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [OrderValidation])
    ], QuoteCompletedGuard);
    return QuoteCompletedGuard;
}());
export { QuoteCompletedGuard };
//# sourceMappingURL=ordercompleted.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/order/wizard/ordercompleted.component.js
// module id = 194
// module chunks = 0